import { join } from "path";

import { ConfigSubdomain } from "@/configuration/tenant-ids";

export const GROUPS_CONFIGURATION_DIR = join(process.cwd(), "configuration", "groups");
export const DEFAULT_CONFIGURATION_DIR = join(process.cwd(), "configuration", "default");
export const SANDBOX_SUBDOMAIN_SUFFIX = "-test";

const ROUTING_SUBDOMAIN_BY_SHARED_FOLDER: Record<string, ConfigSubdomain> = {
  demo: ConfigSubdomain.VALERIE,
};

export const UPPERLINE_CONFIG_SUBDOMAINS = [
  ConfigSubdomain.UPPERLINE_FLORIDA,
  ConfigSubdomain.UPPERLINE_GEORGIA,
  ConfigSubdomain.UPPERLINE_INDIANA,
  ConfigSubdomain.UPPERLINE_TENNESSEE,
] as const;

export type UpperlineConfigSubdomain = (typeof UPPERLINE_CONFIG_SUBDOMAINS)[number];

const UPPERLINE_CONFIG_SUBDOMAIN_SET = new Set<string>(UPPERLINE_CONFIG_SUBDOMAINS);

export function isUpperlineConfigSubdomain(subdomain: string): subdomain is UpperlineConfigSubdomain {
  return UPPERLINE_CONFIG_SUBDOMAIN_SET.has(subdomain);
}

export function mapSubdomains<S extends string, T>(subdomains: readonly S[], value: T): Record<S, T> {
  return Object.fromEntries(subdomains.map((subdomain) => [subdomain, value])) as Record<S, T>;
}

export function getSharedConfigFolderFromSubdomain(subdomain: string): string {
  if (subdomain.endsWith(SANDBOX_SUBDOMAIN_SUFFIX)) {
    return subdomain.slice(0, -SANDBOX_SUBDOMAIN_SUFFIX.length);
  }

  return subdomain;
}

export function isSandboxSubdomain(subdomain: string): boolean {
  return subdomain.endsWith(SANDBOX_SUBDOMAIN_SUFFIX);
}

export function getGroupConfigSubdomain(group: { subdomain: string }): string {
  const folder = getSharedConfigFolderFromSubdomain(group.subdomain);

  return ROUTING_SUBDOMAIN_BY_SHARED_FOLDER[folder] ?? folder;
}
